export enum BillingState {
    control = 1,
    noBilling  = 2,
    preBilling = 3,
    down = 7,
    noControl = 8,
    partial = 9
}
